import {
  FormControl,
  FormHelperText,
  InputAdornment,
  Select,
} from "@mui/material";
import React from "react";

const CustomDropDown = ({
  icon,
  children,
  variant = "outlined",
  stylePropos,
  inputError,
  helperText,
  readonly,
  ...props
}) => {
  return (
    <FormControl
      fullWidth
      variant={variant}
      sx={stylePropos}
      error={inputError}
    >
      <Select
        startAdornment={
          icon ? <InputAdornment position="start">{icon}</InputAdornment> : null
        }
        inputProps={{ readOnly:readonly }}
        {...props}
     
      >
        {children}
      </Select>
      {inputError && helperText && (
        <FormHelperText sx={{ marginLeft: 0}}>{helperText}</FormHelperText>
      )}
    </FormControl>
  );
};

export default CustomDropDown;
